<template>
    <el-dropdown class="service">
        <div class="dropdown-title">
            <img class="dropdown-img" src="../../../../assets/system.svg"  width="13" height="16" alt="">
            <span class="dropdown-text">{{this.text}}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
            <a target="_blank"
                v-for="item in appList"
                :href="`${item.customDomain ? (item.customDomain.indexOf('//') > -1 ? `${item.customDomain}` : `//${item.customDomain}`) : ''}${item.applicationDomain}`"
                :key="item.applicationCode">
                <el-dropdown-item name="system">{{item.applicationName}}</el-dropdown-item>
            </a>
        </el-dropdown-menu>
    </el-dropdown>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        text() {
            const currentPath = this.appList.find(item => {
                if (item.applicationDomain) {
                    return item.applicationDomain.indexOf(window.location.pathname) >= 0;
                }
                return false;
            });
            if (currentPath && currentPath.applicationName) {
                return currentPath.applicationName;
            } else {
                return '';
            }
        },
        ...mapGetters(['appList', 'authority'])
    }
};
</script>
<style lang="less">
    .service{
        cursor: pointer;
        margin-right: 16px;
        .dropdown-title{
            .dropdown-img{
                margin-right: 8px;
                vertical-align: middle;
            }
            .dropdown-text{
                font-size: 12px;
                color: #333333;
                vertical-align: middle;
            }
        }
    }
</style>